import type { JourneyNode } from '../../entities/node';
import type { PresetAvatarCatalog, PresetAvatarOption } from '../../../features/node-editor/services/preset-avatar-loader';
export function resolvePresetAvatar(node: JourneyNode, catalog: PresetAvatarCatalog | null): PresetAvatarOption | null {
  if (node.type !== 'Human' || node.imageSource !== 'preset-avatar' || !node.presetAvatarId) return null;
  return catalog?.options.find((option) => option.presetAvatarId === node.presetAvatarId) ?? null;
}
export function fallbackAvatarLabel(node: JourneyNode): string { return `${node.displayName || 'Human'} fallback portrait`; }
